module.exports = __webpack_public_path__ + "img/logo.56de46d5.png";